import { DocumentsByUserData } from '../../../../types/interfaces'
import { client } from '../../client'

export class DocumentsService {
  public async getDocuments() {
    return client.get<DocumentsByUserData>('/documents')
  }

  public async updateDocuments(body: unknown) {
    return client.post('/documents', body)
  }
}
